import { ButtonProps } from '@chakra-ui/react';

export const closeBtn: ButtonProps = {
  variant: 'unstyled',
  pos: 'absolute',
  top: ['12px', null, '30px'],
  right: [0, null, '34px'],
  boxSize: '40px',
  color: ['white', null, 'gray.700'],

  sx: {
    svg: {
      boxSize: ['26px', null, '33px'],
    },
  },
};
